import {v4 as uuidv4} from "uuid";
import {Elements, FetchedTheme, FetchedThemeElements} from '@/types/theme';
import themeSort from "./themeSort";

const themeMapper = (
    theme: FetchedTheme
) => {


    const css = theme.theme.css || '';
	const tourSteps = theme.theme.tourSteps || '';
    const elements: { [key: string]: FetchedThemeElements } = {
        ...theme.theme.elements,
        "Main Css": {
            css: css,
            status: 'saved',
        },
	    "Tour Steps": {
			jsx: tourSteps,
		    css: '',
		    status: 'saved',
	    }
    };


	console.log("---,", elements)

    const mappedElements: { [key: string]: Elements } = {};

    Object.entries(elements).forEach(([key, value]) => {
        mappedElements[key] = {
            name: key,
            jsx: value?.jsx || '',
            css: value?.css || '',
            mobileCss: value?.mobileCss || '',
            tabletCss: value?.tabletCss || '',

            hints: value.hints || [],
            note: value.note || '',
            protected: key === "Main Css" || key === "Tour Steps",

            status: 'saved',
            id: uuidv4(),
            pinned: false
        };
    });


    return themeSort(Object.values(mappedElements));
};

export default themeMapper;
